<template>
  <section>
    <div
      v-show="showTypeTitle && group.items.length"
      class="has-text-grey is-size-6 is-uppercase has-text-weight-semibold m-l-20"
      :data-e2e="SpotlightCypressAttribute.views.SPOTLIGHT_GROUP_TITLE"
    >
      <p>{{ group.type }}</p>
    </div>
    <component :is="component" v-bind="$props" v-on="$listeners"></component>
  </section>
</template>

<script>
import { SpotlightGroup } from '@/modules/spotlight/models/SpotlightGroup';
import SpotlightGroupComponentFactory from '@/modules/spotlight/factories/SpotlightGroupComponentFactory';
import { SpotlightCypressAttribute } from '@/modules/spotlight/constants/SpotlightCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightGroup',
  props: {
    group: SpotlightGroup,
    showTypeTitle: Boolean
  },
  static: {
    SpotlightCypressAttribute
  },
  computed: {
    component() {
      return SpotlightGroupComponentFactory.build(this.group.type);
    }
  }
};
</script>
